module.exports = __webpack_public_path__ + "img/ekran14@2x.3328b281.png";